// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__23mxz","input":"Switch_input__3SJgJ","wrap":"Switch_wrap__3Yy9e","slider":"Switch_slider__1ynD6","round":"Switch_round__Qg15h","icon":"Switch_icon__1zLYp"};